<template>
<div class="chapter">
<div class="inner_page">
<p class="fm1"><span class="txbf">A SOLDIER’S STORY</span></p>
<div class="inline_group2"><img alt="images" class="landscape" src="images/ch00.jpg"/></div>
<p class="fm"><a id="page_iv"><span class="txbf">FROM IMMIGRANT</span></a></p><a id="page_iv">
<p class="fm"><span class="txbf">TO THE</span></p>
<p class="fm"><span class="txbf">MEDAL OF HONOR</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?198d0c9e